import type { AdminPermission, AdminRole } from '@/types/models'

const rolePermissions: Record<AdminRole, AdminPermission[]> = {
  admin: [
    'dashboard:view', 'settings:edit', 'content:edit', 'media:edit',
    'chatbot:edit', 'appointments:view', 'appointments:edit',
  ],
  editor: ['dashboard:view', 'settings:edit', 'content:edit', 'media:edit', 'chatbot:edit'],
  reception: ['dashboard:view', 'appointments:view', 'appointments:edit'],
}

export function hasPermission(role: AdminRole | null, permission?: AdminPermission) {
  if (!permission) return true
  return role ? rolePermissions[role].includes(permission) : false
}
